// useDevolveDfdModal.js
import { useState } from 'react';

const useDevolveDfdModal = () => {
    const [setDevolveDfdModal, setModalProps] = useState({
        isOpen: false,
        dfd: null,
        onSuccess: () => {}
    });

    const showDevolveDfdModal = (dfd, onSuccess) => {
        setModalProps({
            isOpen: true,
            dfd,
            onSuccess
        });
    };

    const closeDevolveDfdModal = () => {
        setModalProps(prev => ({
            ...prev,
            isOpen: false
        }));
    };

    return {
        setDevolveDfdModal,
        showDevolveDfdModal,
        closeDevolveDfdModal
    };
};

export default useDevolveDfdModal;